import apiClient from './apiConfig';

export const uploadApi = {
  // Upload single image (with compression)
  uploadImage: async (file, filename) => {
    try {
      const formData = new FormData();
      formData.append('name', filename);
      formData.append('file', file);

      const response = await apiClient.post('/upload/image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 60000, // 60 seconds for image upload with compression
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Upload single video (with compression)
  uploadVideo: async (file, filename) => {
    try {
      const formData = new FormData();
      formData.append('name', filename);
      formData.append('file', file);

      const response = await apiClient.post('/upload/video', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 120000, // 120 seconds for video upload (videos are larger)
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Upload single file (legacy - without compression)
  uploadFile: async (file, filename) => {
    try {
      const formData = new FormData();
      formData.append('name', filename);
      formData.append('file', file);

      const response = await apiClient.post('/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        timeout: 60000, // 60 seconds for file upload with processing
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Upload multiple files
  uploadMultipleFiles: async (files) => {
    try {
      const uploadPromises = files.map(async (fileData) => {
        const formData = new FormData();
        formData.append('name', fileData.name);
        formData.append('file', fileData.file);

        return await apiClient.post('/upload', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          timeout: 60000, // 60 seconds for each file upload
        });
      });

      const responses = await Promise.all(uploadPromises);
      return responses.map(response => response.data);
    } catch (error) {
      throw error;
    }
  },

  // Delete uploaded file
  deleteFile: async (filename, type = 'image') => {
    try {
      const response = await apiClient.delete(`/upload/${filename}?type=${type}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get file info
  getFileInfo: async (filename) => {
    try {
      const response = await apiClient.get(`/upload/${filename}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
